class TabsSlider {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('.tabs__step'));
    this.image = root.querySelector('.js-tabs-image');

    if (!this.tabs.length || !this.image) return;

    this.tabs.forEach((tab) => {
      tab.setAttribute('tabindex', '0');
      tab.setAttribute('role', 'button');
      tab.setAttribute(
        'aria-pressed',
        tab.classList.contains('active') ? 'true' : 'false'
      );
    });

    this.bindEvents();

    const initialIndex = this.tabs.findIndex((t) =>
      t.classList.contains('active')
    );
    this.switchTab(initialIndex === -1 ? 0 : initialIndex);
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.switchTab(index);
        }
      });
    });
  }

  switchTab(index) {
    if (index < 0 || index >= this.tabs.length) return;

    this.tabs.forEach((t, i) => {
      const isActive = i === index;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const imagePath = this.tabs[index].dataset.image;
    if (!imagePath) return;

    const imageSrcset = this.tabs[index].dataset.srcset;
    const imageSizes = this.tabs[index].dataset.sizes;

    if (imageSrcset) {
      this.image.srcset = imageSrcset;
    } else {
      this.image.removeAttribute('srcset');
    }

    if (imageSizes) {
      this.image.sizes = imageSizes;
    } else {
      this.image.removeAttribute('sizes');
    }

    this.image.src = imagePath;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tabs').forEach((tabsRoot) => {
    new TabsSlider(tabsRoot);
  });
});
